export const initDateTimeLanguage = (lang) => {
  const langDict = {
    zh: 'zh-cn',
  };
  const langValue = langDict[lang] ?? lang;
  return import(`moment/locale/${langValue}`);
};
